export default __webpack_public_path__ + "assets/images/34ad26e49cb716afcee7e78c7775bbb0.png";